import request from '@/utils/request'


// 查询举报投诉列表
export function listCommunityReport(query) {
  return request({
    url: '/community/admin/report/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询举报投诉分页
export function pageCommunityReport(query) {
  return request({
    url: '/community/admin/report/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询举报投诉详细
export function getCommunityReport(data) {
  return request({
    url: '/community/admin/report/detail',
    method: 'get',
    params: data
  })
}

export function auditCommunityReport(data) {
  return request({
    url: '/community/admin/report/audit',
    method: 'post',
    data: data
  })
}

// 删除举报投诉
export function delCommunityReport(data) {
  return request({
    url: '/community/admin/report/delete',
    method: 'post',
    data: data
  })
}